module.exports = __webpack_public_path__ + "img/plus_btn.659751e4.png";